import { type FC } from "react";
import { UserInfo } from "@/components/fragments/userinfo";
import Link from "next/link";
import { pagesPath } from "@/pathpida/generated/$path";
import { familyCustomerAddressCreateLinkTestId } from "./const";

export const FamilyCustomerAddressCreateLink: FC = () => (
  <UserInfo
    as={Link}
    href={pagesPath.settings.shipment.new._from("shipment").$url()}
    w="100%"
    type="new"
    data-testid={familyCustomerAddressCreateLinkTestId}
  />
);
